import React, { Component } from 'react';
import '@progress/kendo-theme-default/dist/all.css';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';

import Auth from '../../Auth'
import { parseDate, formatDate } from '@telerik/kendo-intl';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import Loading from './Loading'
import { removeGrayBody } from './BodyBg'

import zhMessages from './zh.json';
loadMessages(zhMessages, 'zh-CN');
const auth = new Auth();

export class Paid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            skip: 0,
            pageSize: 10,
            total: 0,
            isLoading: true
        }
    }

    //加载数据
    loadData = (pageIndex, pageSize) => {
        console.log(this.state.isLoading)
        var data = new FormData();
        data.append('page', pageIndex);
        data.append('pageSize', pageSize);

        const options = {
            'headers': {
                ...auth.options()
            }
        }

        fetch('/api/User/FindUserTemplates', {
            ...options,
            method: 'POST',
            body: data,
        })
            .then(
                Response => {
                    console.log(Response.status)

                    if (Response.ok) {
                        return Response.json();
                    }

                    if (Response.status === 401) {
                        auth.signOut();
                        this.props.history.push("/Login")
                    }

                    throw new Error('服务器错误');
                }

            )
            .then(
                (json) => {
                    this.setState({
                        data: json.Data,
                        total: json.Total,
                        skip: pageIndex * pageSize,
                        isLoading: false
                    });
                }
            )
            .catch(error => {
                console.error(error);
            })
    }

    pageChange = (event) => {
        console.log("skip:" + event.page.skip)
        const pageIndex = event.page.skip / event.page.take;

        console.log(pageIndex);

        this.setState({ isLoading: true }, () => {
            this.loadData(pageIndex, this.state.pageSize)
        });
    }

    componentDidMount() {
        removeGrayBody();
        if (auth.isSign()) {
            this.loadData(0, this.state.pageSize);
        }
    }

    download = (e) => {
        console.log(e.currentTarget)

        console.log(e.currentTarget.dataset.id)

        window.location.href = "/api/template/download?id=" + e.currentTarget.dataset.id + "&token=" + auth.token();
    }

    render() {
        return (
            <div className="App">
                <header className="App-header">

                    <h1 className="App-title">{this.state.title}</h1>
                </header>
                <LocalizationProvider language="zh-CN">
                    <IntlProvider locale="zh" >
                        <Grid data={this.state.data}
                            pageable={true}
                            skip={this.state.skip}
                            take={this.state.pageSize}
                            total={this.state.total}
                            onPageChange={this.pageChange}
                        >

                            <GridColumn field="Title" title="模板名称"
                                cell={(props) => (
                                    <td style={{ textAlign: "left" }}>
                                        <a target="_blank" rel="noopener noreferrer" href={props.dataItem.IsMultiple ? "F" + props.dataItem.Number : "D" + props.dataItem.Number}>{props.dataItem.Title}</a>

                                    </td>
                                )}
                            />

                            <GridColumn field="IsMultiple" title="系列" width="80"
                                cell={(props) => (
                                    <td style={{ textAlign: "center" }}>
                                        {props.dataItem.IsMultiple ? "是" : ""}

                                    </td>
                                )}
                            />

                            <GridColumn field="ModifiedOn" width="240" title="购买时间"
                                cell={(props) => (
                                    <td style={{ textAlign: "center" }}>
                                        {formatDate(parseDate(props.dataItem.CreatedOn), "yyyy-MM-dd HH:mm:ss")}
                                    </td>
                                )}
                            />

                            <GridColumn field="ModifiedOn" width="100" title="操作"
                                cell={(props) => (
                                    <td style={{ textAlign: "center" }}>
                                        <Button onClick={this.download} primary={true} data-id={props.dataItem.Id}>下载</Button>
                                    </td>
                                )}
                            />

                        </Grid>
                    </IntlProvider>
                </LocalizationProvider>
                <Loading isLoading={this.state.isLoading} />
            </div>
        );
    }
}

export default Paid